/**
 * @module  experience/shared-experience
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const FLOW = {
  CPS: 'CPS',
  PDP: 'PDP',
  CONFLICT: 'Conflict',
};
